<template>
    <div>

        <section class="feature-section">
            <div class="container">
                <div class="row ">
                    <div class="col-lg-7 text-left">
                        <h2 class="align-left">Skippr's Refund Policy</h2>
                      <h3>Monthly plans</h3>
                      <p>We'll always refund your most-recent monthly payment.</p>
                      <p>Meant to cancel but forgot? No worries, just ask and we'll refund your payment.</p>
                      <h3>Annual plans</h3>
                      <p>We'll refund your full payment if requested in the first 30 days. After that annual plans are not refundable.</p>
                      <em>All refunds are limited to the first 100GB of data.</em>
                    </div>
                    <div class="col-lg-5 text-center m-t-lg">


                        <figure>

<!--                          <div class="m-t-xs font-bold">Paul Hudson - Founder</div>-->

                        </figure>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    export default {
        name: 'PaulHudson',
        props: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>

